import styles from "../../styles/AboutUs/WhatWeDo.module.css";

const WhatWeDo = () => {
  const contactStage = [
    {
      title: "Idea Stage",
      description: [
        "1. Validate your ideas with proven frameworks.",
        "2. Create a clear business model and roadmap for success.",
      ],
      href: "/idea-stage",
    },
    {
      title: "Valley Of Death Stage",
      description: [
        "1. Overcome funding, traction, and resource challenges.",
        "2. Build resilience with strategies tailored to your startup's needs.",
      ],
      href: "/valley-stage",
    },
    {
      title: "Growth Stage",
      description: [
        "1. Scale effectively with optimized processes and tools.",
        "2. Unlock growth opportunities and prepare for expansion.",
      ],
      href: "/growth-stage",
    },
  ];
  return (
    <div className={styles.whatWeDoContainer}>
      <div className="contact-help-title">What We Do</div>
      <div className={styles.whatWeDoDesc}>
        At LovenCoders, we empower startups across three critical stages of
        their journey
      </div>
      <div className="contact-stage-container">
        {contactStage.map((stage, index) => (
          <div className="contact-stage-innercontainer" key={index}>
            <div>
              <div className="contact-stage-title">{stage.title}</div>
              <div className={styles.whatWeDoStageStep}>
                {stage.description.map((stage, index) => (
                  <div key={index}>{stage}</div>
                ))}
              </div>
            </div>
            <div className={styles.whatWeDoStageHref}>
              <a href={stage.href}>Know more</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhatWeDo;

// export default WhatWeDo;
